export class License {
  public static get isLicensed(): boolean {
    const license = localStorage.getItem("licenseKey");
    if (license !== null && license.length > 5) {
      return true;
    } else {
      return false;
    }
  }

  public static setLicense(licenseKey: string) {
    localStorage.setItem("licenseKey", licenseKey);
  }
}
